var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Support_Icon",
    width: 14,
    height: 14,
    "data-name": "Support Icon",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-5{fill:none}.cls-4{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(-23 -117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help_Icon",
    "data-name": "Help Icon",
    transform: "translate(23 117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    fill: "none",
    stroke: "#666",
    "data-name": "Ellipse 14"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    className: "cls-5"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    fill: "none",
    stroke: "#707070",
    strokeWidth: "0.7px",
    d: "M52.288 386.812a1.14 1.14 0 0 0-1.109-1.4h-.861a.294.294 0 0 0-.294.294.249.249 0 0 0 .073.169.621.621 0 0 1 .171.569l-.449 1.833a1.14 1.14 0 0 0 1.11 1.4h.86a.294.294 0 0 0 .294-.294.25.25 0 0 0-.073-.169.62.62 0 0 1-.171-.569z",
    "data-name": "Path 200",
    transform: "translate(-44.382 -378.74)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_15",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: "0.7px",
    "data-name": "Ellipse 15",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.15,
    className: "cls-5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.922fd3f7a48b657d301027ba6ceb6f22.svg";
export { ForwardRef as ReactComponent };